import DetailModal from 'components/Common/DetailModal';
import Grid from '@mui/material/Grid';
import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { HButton } from 'BaseComponents';
import { OrgParameterSelect, OrgParameterSelectByName, OrgParameterTextField } from './OrgParameterSelects';
import {
  PRESET_ORGANIZATION_CATEGORIES,
  PRESET_ORGANIZATION_PARAMETERS_NAMES,
  PRESET_ORGANIZATION_VALUES,
} from './constant';


const EditParam = ({
  open, onClose, row, updateOrgParameters,
}) => {
  const [editRowDetails, setEditRowDetails] = useState({ name: '', value: '', category: '' });

  useEffect(() => {
    setEditRowDetails(row);
  }, [row]);

  const handleValueChange = useCallback((value) => {
    const newRow = { ...editRowDetails };
    newRow.value = value;
    setEditRowDetails(newRow);
  }, [editRowDetails]);

  const handleCategoryChange = useCallback((category) => {
    const newRow = { ...editRowDetails };
    newRow.category = category;
    setEditRowDetails(newRow);
  }, [editRowDetails]);


  const onEdit = () => {
    const data = {
      parameter: {
        value: editRowDetails.value,
        category: editRowDetails.category,
      },
    };
    updateOrgParameters({ paramName: editRowDetails.name, payload: data });
    onClose();
  };

  return (
    <DetailModal
      modalHeading='Edit Parameter'
      onOpen={open}
      onClose={onClose}
    >
      <Box p={2}>
        <Grid>
          <OrgParameterSelect
            options={PRESET_ORGANIZATION_PARAMETERS_NAMES}
            value={editRowDetails.name}
            disabled
            renderInput={(params) => (
              <OrgParameterTextField
                {...params}
                label='Parameter Name'
              />
            )}
          />
          <OrgParameterSelectByName
            nameParameterState={editRowDetails.name}
            options={PRESET_ORGANIZATION_VALUES[editRowDetails?.name]?.options ?? []}
            onChange={(value) => handleValueChange(value)}
            value={editRowDetails.value}
            renderInput={(params) => (
              <OrgParameterTextField
                {...params}
                label='Value'
              />
            )}
            {...(
              PRESET_ORGANIZATION_VALUES[editRowDetails?.name]?.autocompleteProps ?? {}
            )}
          />
          <OrgParameterSelectByName
            nameParameterState={editRowDetails.name}
            options={PRESET_ORGANIZATION_CATEGORIES[editRowDetails?.name]?.options ?? []}
            onChange={(value) => handleCategoryChange(value)}
            value={editRowDetails.category}
            renderInput={(params) => (
              <OrgParameterTextField
                {...params}
                label='Category'
              />
            )}
            {...(
              PRESET_ORGANIZATION_CATEGORIES[editRowDetails?.name]?.autocompleteProps ?? {}
            )}
          />
        </Grid>
      </Box>
      <Box
        display='flex'
        justifyContent='flex-end'
        gap={1}
      >
        <HButton
          onClick={onEdit}
          size='small'
          color='primary'
          variant='contained'
        >
          Save
        </HButton>
        <HButton
          onClick={onClose}
          size='small'
          variant='outlined'
        >
          Close
        </HButton>
      </Box>
    </DetailModal>
  );
};

export default EditParam;
